export default {
  edit_note: 'Notiz bearbeiten',
  add_note: 'Notiz hinzufügen',
  feedback: {
    item_sold_out_one: 'Es tut uns leid, aber wir haben derzeit keine {{items}} mehr.',
    item_sold_out_other: 'Es tut uns leid, aber wir haben derzeit keinen {{items}} mehr.',
    item_unavailable:
      'Dieser Artikel ist nur verfügbar von {{schedule}}. Bitte ändere die Uhrzeit der Bestellung oder entferne den Artikel, um zu bestellen.',
  },
  labels: {
    bogo: '2 für 1',
  },
};
